// No-op defaults — safe if a secondary entry point (e.g. signin-app) never calls configure,
// since neither sidekick nor the RTE are rendered there.
let _getHeaders = () => ({ headers: {} });
let _getApiUrl = () => '';
/**
 * Configures the API bridge with the app's authenticated request infrastructure.
 * Must be called once at app startup before any nx package makes API calls.
 *
 * @param config - The API configuration containing a URL factory and header factory
 *
 * @example
 * ```typescript
 * configureApiBridge({
 *     getApiUrl: () => apiHelper.famlyapiUrl,
 *     getHeaders: () => apiHelper.getRequestHeaders(true),
 * });
 * ```
 */
export const configureApiBridge = (config) => {
    _getHeaders = config.getHeaders;
    _getApiUrl = config.getApiUrl;
};
/**
 * Returns the authenticated request headers for famlyapi calls.
 *
 * @returns An object containing the headers record
 */
export const getRequestHeaders = () => _getHeaders();
/**
 * Returns the base famlyapi URL.
 *
 * @returns The base URL string
 */
export const getApiUrl = () => _getApiUrl();
